"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const escape_reg_exp_1 = require("./escape_reg_exp");
exports.trimChar = (char) => (target) => target.replace(RegExp(`^${escape_reg_exp_1.escapeRegExp(char)}+|${escape_reg_exp_1.escapeRegExp(char)}+$`, "g"), "");
exports.default = exports.trimChar;
//# sourceMappingURL=trim_char.js.map